import { AsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { ModelDto } from '../../../features/firmware-management/dtos/model.dto';
import { axiosInstance } from '../../../features/shared/api/axios-instance';
import { createPathParams } from '../../../features/shared/utils/create-path-params/create-path-params.util';
import { Endpoints } from '../../../features/shared/utils/endpoints-file.utils';
import { withMandant } from '../with-mandant/with-mandant.thunk';
import { GetModelsByBrandModel } from './models/get-models-by-brand.model';

export const getModelsByBrand = <TReturnType>(
  mapper: (dto: ModelDto) => TReturnType
): AsyncThunk<TReturnType[], GetModelsByBrandModel, Record<string, unknown>> =>
  withMandant<GetModelsByBrandModel, TReturnType[]>(
    Endpoints.GET_MODELS_BY_BRAND,
    'get-models-by-brand',
    async ({ args, endpoint }) => {
      if (!args.brandId) {
        return new Promise(resolve => resolve([]));
      }

      const url = createPathParams<'brandId'>(endpoint, {
        brandId: args.brandId,
      });
      const { data }: AxiosResponse<ModelDto[]> = await axiosInstance.get(url);

      return (data || []).map(mapper);
    }
  );
